import {
    APARMENTS,
    APARMENTS_ERROR,
    APARMENTS_SUCCESS,
    ADD_APARMENT,
    ADD_APARMENT_ERROR,
    ADD_APARMENT_SUCCESS,
    UPDATE_APARMENT,
    UPDATE_APARMENT_ERROR,
    UPDATE_APARMENT_SUCCESS,
    DELETE_APARMENT,
    DELETE_APARMENT_ERROR,
    DELETE_APARMENT_SUCCESS
} from '../constants/aparmentsConstants';


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: '',
    aparmentsData:[]
};


function aparmentReducer(state = initialState, action) {
    switch (action.type) {
        case APARMENTS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'Aparments',
                'loadingMessage': 'THE APARMENTS ARE BEING LOADED',
                'type': action.type

            });
        case APARMENTS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'aparmentsData': '',
                'type': action.type
            });
        case APARMENTS_SUCCESS:


            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'aparmentsData': action.data,
                'type': action.type

            });
        case ADD_APARMENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'APARMENT',
                'loadingMessage': 'THE APARMENT IS BEING SAVED',
                'type': action.type
            });
        case ADD_APARMENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_APARMENT_SUCCESS:
            let addAparmentData = state.aparmentsData ? [...state.aparmentsData] : []
            addAparmentData.push(action.data);

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'aparmentsData': addAparmentData,
                'type': action.type
            });
        case UPDATE_APARMENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'APARMENTS',
                'loadingMessage': 'THE APARMENT IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_APARMENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_APARMENT_SUCCESS:

            let updAparmentData = state.aparmentsData ? state.aparmentsData : []

            updAparmentData = updAparmentData.map((item) => { return item._id === action.data._id ? action.data : item });

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'aparmentsData': updAparmentData,
                'type': action.type
            });
        case DELETE_APARMENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'APARMENT',
                'loadingMessage': 'THE APARMENT IS BEING DELETED',
                'type': action.type
            });
        case DELETE_APARMENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_APARMENT_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'aparmentsData': (state.aparmentsData) ? state.aparmentsData.filter(item => item._id !== action.data) : [],
                'type': action.type
            });
        default:
            return state;
    }
};

export default aparmentReducer